<template>
  <CFlex
    v-if="wrap"
    :justify="justify"
    w="100%"
    :mb="mb"
  >
    <CBox
      :bg="bg"
      :border="border"
      borderRadius="16px"
      p="12px"
      w="100%"
      :maxW="maxW"
      textAlign="left"
    >
      <CBox
        v-if="resolvedPreviewUrl"
        bg="rgba(255, 255, 255, 0.6)"
        borderRadius="12px"
        p="8px"
        overflow="hidden"
      >
        <CBox
          as="img"
          :src="resolvedPreviewUrl"
          :alt="resolvedName"
          w="100%"
          maxH="220px"
          h="auto"
          objectFit="contain"
          display="block"
        />
      </CBox>
      <CFlex
        v-else
        bg="rgba(255, 255, 255, 0.6)"
        borderRadius="12px"
        minH="140px"
        align="center"
        justify="center"
      >
        <OmtTypography
          as="h2-bold"
          m="0"
          >{{ resolvedExtension }}</OmtTypography
        >
      </CFlex>

      <CFlex
        mt="12px"
        align="center"
      >
        <CBox
          flex="1"
          mr="12px"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          color="#111827"
        >
          <OmtTypography
            as="p1"
            m="0"
            >{{ resolvedName }}</OmtTypography
          >
        </CBox>
        <OmtButton
          v-if="removable"
          bg="#ffffff"
          border="1px solid rgba(16, 24, 40, 0.12)"
          borderRadius="9999px"
          height="32px"
          px="12px"
          type="button"
          @click="$emit('remove')"
        >
          <OmtTypography
            as="p0"
            m="0"
            >Remover</OmtTypography
          >
        </OmtButton>
      </CFlex>
    </CBox>
  </CFlex>
  <CBox
    v-else
    :bg="bg"
    :border="border"
    borderRadius="16px"
    p="12px"
    w="100%"
    :maxW="maxW"
    textAlign="left"
  >
    <CBox
      v-if="resolvedPreviewUrl"
      bg="rgba(255, 255, 255, 0.6)"
      borderRadius="12px"
      p="8px"
      overflow="hidden"
    >
      <CBox
        as="img"
        :src="resolvedPreviewUrl"
        :alt="resolvedName"
        w="100%"
        maxH="220px"
        h="auto"
        objectFit="contain"
        display="block"
      />
    </CBox>
    <CFlex
      v-else
      bg="rgba(255, 255, 255, 0.6)"
      borderRadius="12px"
      minH="140px"
      align="center"
      justify="center"
    >
      <OmtTypography
        as="h2-bold"
        m="0"
        >{{ resolvedExtension }}</OmtTypography
      >
    </CFlex>

    <CFlex
      mt="12px"
      align="center"
    >
      <CBox
        flex="1"
        mr="12px"
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        color="#111827"
      >
        <OmtTypography
          as="p1"
          m="0"
          >{{ resolvedName }}</OmtTypography
        >
      </CBox>
      <OmtButton
        v-if="removable"
        bg="#ffffff"
        border="1px solid rgba(16, 24, 40, 0.12)"
        borderRadius="9999px"
        height="32px"
        px="12px"
        type="button"
        @click="$emit('remove')"
      >
        <OmtTypography
          as="p0"
          m="0"
          >Remover</OmtTypography
        >
      </OmtButton>
    </CFlex>
  </CBox>
</template>

<script>
import { CBox, CFlex } from "@chakra-ui/vue";

export default {
  name: "PreviewFile",
  components: { CBox, CFlex },
  props: {
    file: { type: [Object], default: null },
    attachment: { type: Object, default: null },
    previewUrl: { type: String, default: "" },
    name: { type: String, default: "" },
    extension: { type: String, default: "" },
    removable: { type: Boolean, default: false },
    wrap: { type: Boolean, default: false },
    justify: { type: String, default: "end" },
    mb: { type: String, default: "0" },
    maxW: { type: [Array, String], default: () => ["92%", "520px"] },
    bg: { type: String, default: "#E6F0FF" },
    border: { type: String, default: "1px solid rgba(29, 78, 216, 0.14)" }
  },
  data() {
    return {
      localPreviewUrl: ""
    };
  },
  computed: {
    resolvedName() {
      return this.name || this.attachment?.name || this.file?.name || "";
    },
    resolvedExtension() {
      if (this.extension) return this.extension;
      if (this.attachment?.extension) return this.attachment.extension;
      return this.getFileExtensionFromName(this.file?.name || "");
    },
    resolvedPreviewUrl() {
      return this.previewUrl || this.attachment?.previewUrl || this.localPreviewUrl || "";
    }
  },
  watch: {
    file: {
      immediate: true,
      handler(file) {
        if (this.previewUrl || this.attachment?.previewUrl) return;
        this.revokeLocalPreviewUrl();
        if (file && this.shouldCreatePreviewForFile(file)) {
          this.localPreviewUrl = URL.createObjectURL(file);
        }
      }
    }
  },
  beforeDestroy() {
    this.revokeLocalPreviewUrl();
  },
  methods: {
    shouldCreatePreviewForFile(file) {
      const type = file?.type || "";
      if (type.startsWith("image/")) return true;
      const ext = this.getFileExtensionFromName(file?.name || "").toLowerCase();
      return ["png", "jpg", "jpeg", "webp", "gif", "bmp", "heic", "heif"].includes(ext);
    },
    revokeLocalPreviewUrl() {
      if (this.localPreviewUrl) {
        URL.revokeObjectURL(this.localPreviewUrl);
        this.localPreviewUrl = "";
      }
    },
    getFileExtensionFromName(name) {
      const n = (name || "").trim();
      const idx = n.lastIndexOf(".");
      if (idx === -1) return "ARQ";
      const ext = n.slice(idx + 1).trim();
      return (ext || "ARQ").slice(0, 6).toUpperCase();
    }
  }
};
</script>
